import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class TableComponent {
  @Input() fontSize : string = "";
  @Input() minSize : string = "";
  @Input() theme : string = "";
  @Input() marginBottom : boolean = false;
}
